const colorMap: Record<string, string> = {
  gray: 'bg-silver-100 text-silver-700',
  green: 'bg-emerald-100 text-emerald-700',
  yellow: 'bg-amber-100 text-amber-700',
  red: 'bg-red-100 text-red-700',
  blue: 'bg-blue-100 text-blue-700',
  gold: 'bg-gold-100 text-gold-800',
};

const statusColors: Record<string, string> = {
  draft: 'gray',
  pending_upload: 'yellow',
  pending: 'yellow',
  uploaded: 'blue',
  processing: 'blue',
  in_progress: 'blue',
  completed: 'green',
  rejected: 'red',
  exception: 'red',
  failed: 'red',
  cancelled: 'gray',
  partial: 'yellow',
  active: 'green',
  inactive: 'gray',
};

interface BadgeProps {
  children: string;
  color?: keyof typeof colorMap;
}

export function Badge({ children, color }: BadgeProps) {
  const resolved = color ?? statusColors[children.toLowerCase()] ?? 'gray';
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${colorMap[resolved]}`}>
      {children.replace(/_/g, ' ')}
    </span>
  );
}
